import { resolveApiAssetUrl } from './api';

// Sekme simgesi panelden yönetilir (`settings.favicon_url`). index.html'deki
// <link rel="icon"> paketle gelen varsayılanı gösterir; ayar yüklendiğinde
// adresi burada değiştirilir. Ayar boşaltılırsa varsayılana geri dönülür.
const DEFAULT_HREF = `${process.env.PUBLIC_URL || ''}/favicon.svg`;
// Ayarlar ancak /settings yanıtı geldikten sonra bilinir; o ana kadar sekmede
// paketin varsayılan simgesi durur. Son uygulanan adres saklanır ve
// index.html açılışta onu kullanır — tema önbelleğiyle aynı yöntem.
const FAVICON_CACHE_KEY = 'app:favicon-v1';

const MIME_TYPES = {
  svg: 'image/svg+xml',
  png: 'image/png',
  ico: 'image/x-icon',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
};

// Tür yalnızca uzantıdan türetilir; sorgu dizesi ve yol parçaları elenir.
const mimeType = (href) => {
  const extension = String(href).split(/[?#]/)[0].split('.').pop().toLowerCase();
  return MIME_TYPES[extension] || '';
};

const cacheFavicon = (href) => {
  try {
    if (href === DEFAULT_HREF) localStorage.removeItem(FAVICON_CACHE_KEY);
    else localStorage.setItem(FAVICON_CACHE_KEY, href);
  } catch {
    // Katı/gizli tarayıcı oturumlarında localStorage kullanılamayabilir.
  }
};

export const applyFavicon = (url) => {
  if (typeof document === 'undefined') return;
  const href = String(url || '').trim()
    ? resolveApiAssetUrl(String(url).trim())
    : DEFAULT_HREF;
  cacheFavicon(href);

  let link = document.querySelector('link[rel~="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  // Aynı adres yeniden atanırsa tarayıcı gereksiz istek yapmasın.
  if (link.getAttribute('href') === href) return;
  const type = mimeType(href);
  if (type) link.setAttribute('type', type);
  else link.removeAttribute('type');
  link.setAttribute('href', href);
};

export default applyFavicon;
